import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FireflyMobileScrollService {
  scrollTop$: Subject<void> = new Subject();
}
